export enum SystemStatus {
    New,
    Ready
}
